import { SCENARIO_COLORS } from '@/common/scenarioColors'
import type { TimelineLane } from '@/components/analytics/ScenarioRunTimeline'

// 複数機体の合算時に、機体 (lane) ごとの表示名と色を決める。
// 並び順は mergeScenarioStats が付けた fork_ids (= runs の lane 番号) に揃える
export function buildForkLanes(forkIds: string[] | undefined): TimelineLane[] {
  if (!forkIds || forkIds.length === 0) return []
  return forkIds.map((id, i) => ({
    id,
    label: id,
    color: SCENARIO_COLORS[i % SCENARIO_COLORS.length],
  }))
}
